/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaxLength/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers'
import Info from './Info/index'
import InputSmallLabel from 'DesignSystem/InputSmallLabel/index'
import React from 'react'
import ToggleLabels from 'DesignSystem/ToggleLabels/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MaxLength({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/CustomPlan/MaxLength",
  onChange,
  textNo = "total"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let rulesetCustomPaymentPlanRulesetMaxLengthValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.max_length',
})
let rulesetCustomPaymentPlanRulesetMaxLengthChangeData = fromData.useDataChange({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.max_length',
})
let rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.max_length_type',
})
let constantData = 'total'
let aggregateData = fromAggregate.equals(rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData, constantData)
let rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.max_length_type',
})
let constantData1 = 'relative'
let aggregateData1 = fromAggregate.equals(rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData1, constantData1)
let onClickNo = fromHelpers.useOnClickNo({
  children,
  viewPath,
  onChange,
  textNo
  
})
let onClickYes = fromHelpers.useOnClickYes({
  children,
  viewPath,
  onChange,
  textNo
  
})
  return (<React.Fragment
>
<div
  data-testid="MaxLength.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1qz9v0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<InputSmallLabel
  viewPath={`${viewPath}/InputSmallLabel`}
 label="maximum length"
 type="text"
 data="ruleset.custom_payment_plan_ruleset.max_length"
 value={rulesetCustomPaymentPlanRulesetMaxLengthValueData}
 onChange={rulesetCustomPaymentPlanRulesetMaxLengthChangeData}
/>
<ToggleLabels
  viewPath={`${viewPath}/ToggleLabels`}
 paddingTop={10}
 paddingBottom={10}
 data="ruleset.custom_payment_plan_ruleset.max_length_type"
 data="'total'"
 aggregate="/Data/aggregate.js equals"
 isSelectedNo={aggregateData}
 onClickNo={onClickNo}
 textNo={textNo}
 data="ruleset.custom_payment_plan_ruleset.max_length_type"
 data="'relative'"
 aggregate="/Data/aggregate.js equals"
 isSelectedYes={aggregateData1}
 onClickYes={onClickYes}
 textYes="relative"
/>
</div>
<Info
  viewPath={`${viewPath}/Info`}
/>
{children}
</React.Fragment>)
}